var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type == 'ocs')?_c('ocs'):_vm._e(),(_vm.type == 'ems')?_c('ems'):_vm._e(),(_vm.type == 'emsAviation')?_c('emsAviation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }